module.exports = __webpack_public_path__ + "img/selected4-min.32faf444.png";